export const EnvEnum = Object.freeze({
    LOCAL: 'local',
    STAGING: 'staging',
    LIVE: 'live'
});

export default EnvEnum;
